var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReadwiseThumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.572 21.2104C23.1568 22.1709 23.6338 22.4903 24.6094 22.6047V23.5652H19.7962L15.2875 16.136H14.161V21.0055C14.161 22.3093 14.4871 22.4903 15.875 22.6047V23.5652H8.60938V22.6047C9.99727 22.4903 10.3234 22.3067 10.3234 21.0055V10.125C10.3234 8.79989 10.0404 8.64023 8.60938 8.52581V7.56525H16.0879C20.5966 7.56525 22.952 8.50186 22.952 11.7934C22.952 14.284 21.7258 15.4734 19.2545 15.8832L22.572 21.2104ZM19.1934 13.2464C19.1934 13.2464 18.6032 9.97339 18.9859 9.27893L14.1026 14.6034C15.2965 13.6242 18.9105 13.6082 18.9105 13.6082C19.0829 13.5709 19.2015 13.4193 19.1934 13.2464Z",
    fill: "white"
  })));
}

export default SvgReadwiseThumb;